<template>
  <div class="asc-doc-mgmt-help-about--wrapper">
    <asc-container>
      <template slot="header">
        <v-row>
          <v-col
            ><asc-surface-title
              class="asc-doc-mgmt-help-about--wrapper-title"
              title="HELP DOCUMENTS"
            />
          </v-col>
          <v-col>
            <asc-accent-button
              v-if="isUploadNewDocmentAvailable"
              class="asc-doc-mgmt-help-about--wrapper-button"
              button-text="Upload New Document"
              :on-click="handleUploadNewDoc"
            ></asc-accent-button>
          </v-col>
        </v-row>
      </template>
      <asc-doc-mgmt-help-about-grid-wrapper
        :values="values"
        :upload-new-doc-available="isUploadNewDocmentAvailable"
        :upload-new-doc-disabled="uploadNewDocDisabled"
        :deselect-all-user-guides="deselectAllUserGuides"
        :grid-disabled="gridDisabled"
        v-on="$listeners"
      />
      <asc-doc-mgmt-content-editor-wrapper
        :contents="contents"
        :user="user"
        v-on="$listeners"
      />
    </asc-container>
  </div>
</template>

<script>
import AscContainer from '@/components/atoms/AscContainer'
import AscDocMgmtHelpAboutGridWrapper from '@/components/organisms/AscDocMgmtHelpAboutGridWrapper'
import AscDocMgmtContentEditorWrapper from '@/components/organisms/AscDocMgmtContentEditorWrapper'
import AscSurfaceTitle from '@/components/atoms/AscSurfaceTitle'
import AscAccentButton from '@/components/atoms/AscAccentButton'

export default {
  name: 'AscDocMgmtHelpAboutWrapper',

  components: {
    AscContainer,
    AscDocMgmtHelpAboutGridWrapper,
    AscDocMgmtContentEditorWrapper,
    AscSurfaceTitle,
    AscAccentButton,
  },

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    contents: {
      type: Array,
      default: () => [],
    },
    user: {
      type: Object,
      default: () => {},
    },
    uploadNewDocDisabled: {
      type: Boolean,
      default: false,
    },
    selectedUserGuides: {
      type: Array,
      default: () => [],
    },
    deselectAllUserGuides: {
      type: Boolean,
      default: false,
    },
    gridDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {}
  },

  computed: {
    isUploadNewDocmentAvailable() {
      return true
    },
  },

  methods: {
    handleUploadNewDoc() {
      this.$emit('onUploadNewDoc')
    },
  },
}
</script>

<style lang="scss">
.asc-doc-mgmt-help-about--wrapper {
  &-title {
    padding-left: 20px;
    padding-top: 10px;
    vertical-align: center;
  }

  &-button {
    display: flex;
    justify-content: flex-end;
    padding-right: 23px;
  }
}
</style>
